import { createFileRoute } from "@tanstack/react-router";
import React from "react";
import { JobOffer } from "@/features/job-offer/forms/job-offer";

export const Route = createFileRoute(
  "/_org/org/bu/$organizationBusinessUnitId/jobs/offer/edit/$id/",
)({
  component: EditJobOfferPage,
});

function EditJobOfferPage() {
  const { id } = Route.useParams();

  if (!id) {
    return <div>No job offer ID</div>;
  }

  return <JobOffer jobId={id} />;
}
